import { type TagSemanticoDTO } from '@framework/api-client/api/backoffice/schemas/tagSemanticoDTO.ts';
import { type CampoSemantico } from '@framework/api-client/api/inquiries-compile/schemas/campoSemantico.ts';
import { GetTagSemanticiTipoSezione } from '@framework/api-client/api/users/schemas/getTagSemanticiTipoSezione.ts';
import { type ColumnType } from 'antd/es/table';

export interface IObjectWithSemanticFields {
  campiSemantici?: CampoSemantico[] | null;
}

/**
 * Mappa i tag semantici visibili in colonne della tabella
 */
export function getSemanticTagColumn<T extends IObjectWithSemanticFields>(
  tag: TagSemanticoDTO,
  sectionType: GetTagSemanticiTipoSezione = GetTagSemanticiTipoSezione.BACKOFFICE,
): ColumnType<T> {
  const dataIndex =
    sectionType === GetTagSemanticiTipoSezione.FRONTOFFICE
      ? `CAMPO_SEMANTICO.${tag.tipo}.${tag.id}`
      : `CAMPO_SEMANTICO.${tag.id}`;

  return {
    title: tag.titolo ?? tag.nome ?? '<undefined>',
    dataIndex,
    sorter: true,
    key: `semanticTag.${tag.nome}`,
    /**
     * Al momento non è mai utilizzato: se non c'è il column picker, non viene
     * mostrata la colonna a prescindere (Tag Semantico)
     */
    columnFlags: ['enableScroll'],
    render: (_, record) => {
      if (!record.campiSemantici) return null;
      const tagValue = record.campiSemantici.find(
        t => t.tagSemantico?.id === tag.id,
      )?.valore;
      return tagValue;
    },
  };
}

export function getSemanticTagColumns(
  tags: TagSemanticoDTO[],
  sectionType: GetTagSemanticiTipoSezione = GetTagSemanticiTipoSezione.BACKOFFICE,
): Array<ColumnType<IObjectWithSemanticFields>> {
  return tags.map(tag => getSemanticTagColumn(tag, sectionType));
}
